import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Button, Form, Input, NavBar, Toast} from "antd-mobile";
import React, {useEffect, useState} from "react";
import {hubtelVerify} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const HubtelVerify = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const location = useLocation();
    const [clientReferenceId, setClientReferenceId] = useState<string>('');
    const [form] = Form.useForm();

    useEffect(() => {
        if (location.state) {
            setClientReferenceId(location.state.clientReferenceId);
            form.setFieldsValue({orderNo: location.state.orderNo})
        }
    }, [location, setClientReferenceId, form])

    const back = () => {
        navigate(-1);
    };
    const onFinish = (values: any) => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelVerify(clientReferenceId, values.otpCode).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                Toast.show({icon: 'success', content: 'Verify Success!', duration: TOASTDURATION})
                back()
            } else {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            }
        }).catch((err: any) => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }

    return <div style={{display: "flex", flexDirection: "column", width: '100%', minHeight: '100vh', backgroundColor: '#F5F6FA', resize: "none", overflow: "auto"}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>Preapproval Details</NavBar>
        <div>
            <Form
                onFinish={onFinish}
                mode={'card'}
                form={form}
                requiredMarkStyle='asterisk'
                footer={<Button shape='rounded' type='submit' block color='primary' size='middle'>{t('create_order_submit')}</Button>}>
                <Form.Header>{'Please Enter otpCode'}</Form.Header>
                <Form.Item name='orderNo' label={t('common_ordere_no')} rules={[{ required: true, message: t('common_ordere_no') }]}>
                    <Input disabled placeholder={t('common_ordere_no')} />
                </Form.Item>
                <Form.Item name='otpCode' label={'otpCode'} rules={[{ required: true, message: 'otpCode' }]}>
                    <Input placeholder={'otpCode'} />
                </Form.Item>
            </Form>
        </div>
    </div>
}
export default HubtelVerify
